export const mergeInitialWizardData = (currentWizardData, additionalWizardData) => ({
  ...currentWizardData,
  ...additionalWizardData,
});
